import { AUTH_CONFIG } from '@auth-oauth2/config'
import { AuthOauth2 } from '@auth-oauth2/core/auth'
import { getClientId } from '@auth-oauth2/core/clientId'
import { getIssuerUrl } from '@auth-oauth2/core/issuerUrl'
import sessionStorage from '@core/helpers/sessionStorage'

export default function authOauthPluginClient(ctx, inject) {
  const options = { ...AUTH_CONFIG }

  if (!ctx.store.getters['auth/isNewAuthEnabled']) {
    return
  }

  // get auth issuer url dynamically depending on the host
  options.domainBaseUrl = getIssuerUrl(ctx.store.getters['config/apiBaseUrl'])

  // get client id dynamically depending on the region
  options.clientId = getClientId(
    ctx.store.getters['config/apiBaseUrl'],
    ctx.store.getters['config/marketplace'],
  )

  inject('auth', new AuthOauth2(options, ctx, sessionStorage))
}
